import type { GeoDataService } from "@app/services/geo-data-service";
import type { SeatSelectionFirstTrackingProperties } from "@app/types/tracking/results";

import {
  addToCart,
  addToCartAcceptNewPrice,
  addToCartDiscard,
  addToCartRefuseNewPrice
} from "./add-to-cart/";
import * as types from "../constants/action-types";

export { closeDrawer, openDrawer } from "../../../store/state/drawers";
export { closeModal, openModal } from "../../../store/state/modals";
export { logUserIn } from "../../../store/state/user";
export { fetchAlternativeRoutes } from "../state/alternative-routes";
export { initAndPollAlternativeRoutesSearch } from "../state/alternative-routes-search";
export { removeExcludedSources, resetFilters } from "../state/filters";
export {
  startInventoryOrchestration,
  startInventoryOrchestrationGeoEntities
} from "../state/inventory";
export { toggleOpenedDetails } from "../state/opened-details";
export { updateSearch } from "../state/search";
export { fetchDateTabsPrices } from "../state/search-metadata";
export { sortDepartures } from "../state/sorting";
export { resetSourcesOutageStatus } from "../state/sources-outage-status";
export { addSearchedRoute } from "../state/searched-routes";
export {
  startInterconnectedTripsPolling,
  startTripsPolling,
  tripsPollingFailure
} from "../state/trips-polling-complete";

export {
  addToCart,
  addToCartAcceptNewPrice,
  addToCartDiscard,
  addToCartRefuseNewPrice
};

export function setBBYieldifyEventData(geoData: GeoDataService) {
  return {
    type: types.SET_BB_YIELDIFY_EVENT_DATA,
    geoData
  };
}

export function trackSelectedTrip(id: string) {
  return {
    type: types.TRACK_SELECTED_TRIP,
    id
  };
}

export function trackViewTicketOptions(id: string) {
  return {
    type: types.TRACK_VIEW_TICKET_OPTIONS,
    id
  };
}

export function trackViewAsyncCart(
  trip_id: string,
  ssf_properties?: SeatSelectionFirstTrackingProperties
) {
  return {
    type: types.TRACK_VIEW_ASYNC_CART,
    id: trip_id,
    ssf_properties
  };
}

export function trackViewSeatSelectionFirst(id: string) {
  return {
    type: types.TRACK_VIEW_SEAT_SELECTION,
    id
  };
}
